export const environment = {
    production: true,
    tenant: 'mondis',
    loginToken: '5aaa8984-16da-478e-8828-46266bda43b5',
    apiServerUrl: `/api-server`,
    firebase: {
        apiKey: "AIzaSyDH6IucWuo-rRAs69sDmlQwx-Od1Hk1ROc",
        authDomain: "angie-iot-prod-d57ba.firebaseapp.com",
        projectId: "angie-iot-prod-d57ba",
        storageBucket: "angie-iot-prod-d57ba.appspot.com",
        messagingSenderId: "512013221922",
        appId: "1:512013221922:web:a95b9a56dd96b95414ca7b",
        measurementId: "G-D6L4N3K1KG"
    },
    mapTilesAddress: 'https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png',
    sentry: {
        enabled: true,
        environment: 'production',
    }
};
